module.exports = "/to_the_arctic_for_practice/_next/static/videos/11-4493d5674bedffc0b9a5181a39236b83.mp4";